import { render, staticRenderFns } from "./workspace-window.vue?vue&type=template&id=1d66fcb0&scoped=true&"
import script from "./workspace-window.vue?vue&type=script&lang=js&"
export * from "./workspace-window.vue?vue&type=script&lang=js&"
import style0 from "./workspace-window.vue?vue&type=style&index=0&id=1d66fcb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66fcb0",
  null
  
)

export default component.exports